import { AppSourceFallback } from '@/components/shared/app-source/fallback'
import { ViewAppButtonFallback } from '@/components/shared/view-app/fallback'
import { DiagramFallback } from '@/routes/app/tabs/overview/diagram/fallback'
import { AppLatestDeploymentsFallback } from '@/routes/app/tabs/overview/latest-deployments/fallback'
import * as Styled from '@/routes/app/tabs/overview/styles'

export const OverviewTabFallback = () => {
  return (
    <Styled.OverviewPageContainer>
      <Styled.OverviewPageHeader>
        <AppSourceFallback />
        <ViewAppButtonFallback />
      </Styled.OverviewPageHeader>
      <DiagramFallback />
      <AppLatestDeploymentsFallback />
    </Styled.OverviewPageContainer>
  )
}
